module.exports = __webpack_public_path__ + "img/mizrahi.1dbba7fb.jpg";